module.exports = __webpack_public_path__ + "420cda85d8b0111f61da0f437f3b6a1a.svg";